module.exports = __webpack_public_path__ + "img/c-bg1.1986f18c.jpg";